<?xml version="1.0" encoding="UTF-8"?>
<svg id="aA" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 19.6 19.6">
    <defs>
        <style>
            .kA{fill:#2684ff;}
            .lA{fill:url(#fA);}
            .mA{fill:url(#gA);}
            .nA{fill:url(#iA);}
            .oA{fill:url(#hA);}
            .pA{fill:url(#dA);}
            .qA{fill:url(#eA);}
            .rA{fill:none;}
            .sA{fill:url(#jA);}
        </style>
        <linearGradient id="dA" x1="5.77" y1="-814.36" x2="5.08" y2="-796.18"
                        gradientTransform="translate(0 -795.31) scale(1 -1)" gradientUnits="userSpaceOnUse">
            <stop offset=".5" stop-color="#2684ff"/>
            <stop offset="1" stop-color="#0052cc"/>
        </linearGradient>
        <linearGradient id="eA" x1="19.05" y1="-805.91" x2="10.99" y2="-814.24"
                        gradientTransform="translate(0 -795.31) scale(1 -1)" gradientUnits="userSpaceOnUse">
            <stop offset="0" stop-color="#0e65df"/>
            <stop offset="1" stop-color="#0052cc"/>
        </linearGradient>
        <linearGradient id="fA" x1="14.35" y1="-796.01" x2="14.35" y2="-805.11"
                        gradientTransform="translate(0 -795.31) scale(1 -1)" gradientUnits="userSpaceOnUse">
            <stop offset="0" stop-color="#2684ff"/>
            <stop offset=".59" stop-color="#156ee8"/>
            <stop offset="1" stop-color="#0e65df"/>
        </linearGradient>
        <linearGradient id="gA" x1=".78" y1="-805.53" x2="13.96" y2="-805.53"
                        gradientTransform="translate(0 -795.31) scale(1 -1)" gradientUnits="userSpaceOnUse">
            <stop offset=".26" stop-color="#2684ff"/>
            <stop offset="1" stop-color="#0e65df"/>
        </linearGradient>
        <linearGradient id="hA" x1="15.17" y1="-807.71" x2="18.05" y2="-804.65"
                        gradientTransform="translate(0 -795.31) scale(1 -1)" gradientUnits="userSpaceOnUse">
            <stop offset="0" stop-color="#0052cc"/>
            <stop offset="1" stop-color="#0e65df"/>
        </linearGradient>
        <linearGradient id="iA" x1="11.9" y1="-814.21" x2="11.9" y2="-796.82"
                        gradientTransform="translate(0 -795.31) scale(1 -1)" gradientUnits="userSpaceOnUse">
            <stop offset=".36" stop-color="#2684ff"/>
            <stop offset="1" stop-color="#0052cc"/>
        </linearGradient>
        <linearGradient id="jA" x1="-5135.73" y1="-814.21" x2="-5135.73" y2="-796.83"
                        gradientTransform="translate(-5128.1 -795.31) rotate(-180)" gradientUnits="userSpaceOnUse">
            <stop offset=".06" stop-color="#2684ff"/>
            <stop offset=".58" stop-color="#0052cc"/>
            <stop offset="1" stop-color="#2684ff"/>
        </linearGradient>
    </defs>
    <g id="bA">
        <g id="cA">
            <g>
                <rect class="rA" width="19.6" height="19.6"/>
                <g>
                    <g>
                        <path class="pA"
                              d="M9.8,18.9C4.76,18.9,.7,14.84,.7,9.8S4.76,.7,9.8,.7v1.47c-4.2,0-7.63,3.43-7.63,7.63s3.43,7.63,7.63,7.63v1.47Z"/>
                        <path class="qA" d="M9.8,18.9v-1.47c4.2,0,7.63-3.43,7.63-7.63h1.47c0,5.04-4.06,9.1-9.1,9.1Z"/>
                        <path class="lA" d="M18.9,9.8h-1.47c0-4.2-3.43-7.63-7.63-7.63V.7c5.04,0,9.1,4.06,9.1,9.1Z"/>
                    </g>
                    <path class="mA"
                          d="M13.65,12.6c-.98-.21-1.75-.56-3.01-1.12-.35-.14-.77-.35-1.19-.56-.28-.14-.49-.21-.77-.35-1.89-.84-2.94-1.33-4.27-1.33-.91,0-1.61,.28-1.96,.7-.28,.28-.35,.7-.28,1.12l-1.4,.28c-.07-.77,.14-1.61,.63-2.24,.49-.56,1.4-1.26,3.08-1.26s2.87,.56,4.83,1.47c.21,.07,.49,.21,.77,.35,.42,.21,.84,.35,1.19,.56,1.19,.56,1.89,.84,2.66,.98l-.28,1.4Z"/>
                    <path class="oA"
                          d="M15.12,12.74c-.49,0-.98-.07-1.4-.14l.28-1.4c.35,.07,.77,.14,1.12,.14,.91,0,1.54-.21,1.96-.63,.42-.42,.42-.98,.35-1.19l1.47-.14c.07,.91-.21,1.68-.77,2.31-.49,.42-1.4,1.05-3.01,1.05Z"/>
                    <path class="nA"
                          d="M9.8,18.9v-1.47c2.1,0,3.29-2.1,3.29-5.67s-1.26-6.51-3.85-9.24l1.05-.98c2.87,3.01,4.27,6.37,4.27,10.29,0,4.34-1.82,7.07-4.76,7.07Z"/>
                    <path class="sA"
                          d="M9.8,18.9c-3.15,0-4.9-2.52-4.9-7C4.9,6.72,7.14,3.85,9.24,1.54l1.12,.98c-2.52,2.66-4.06,5.18-4.06,9.38,0,4.62,1.89,5.53,3.5,5.53v1.47Z"/>
                    <circle class="kA" cx="5.95" cy="8.89" r="1.68"/>
                    <circle class="kA" cx="13.72" cy="11.76" r="1.68"/>
                    <circle class="kA" cx="9.8" cy="1.68" r="1.68"/>
                </g>
            </g>
        </g>
    </g>
</svg>